import React from "react";
import { getLabel } from "../../../data/labels";

export default function MstbetHorseTicketHeader(props) {
    const ticketData = props.ticketData;
	const conf = props.conf;
	const frontendType = props.frontendType;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	let typeGame = ticketData?.type_game;
    const isFixedOddType = typeGame == 'FIXEDODD';
    const isTotPsrType =  (typeGame == 'TOT' ||  typeGame == 'PSR');
    const ticket = ticketData?.ticket?.[0];

    let palDesc = "";
    let qfDiscl = null;
    let topPsrDiscl = null;

    if(isFixedOddType) {
        if("0" == ticketData?.ticket_type){
            qfDiscl = ticket?.bets?.length == 1? getLabel("printer.plain_ticket.header.single_bets"):  getLabel("printer.plain_ticket.header.multiple_bets");
        }else if("1" == ticketData?.ticket_type) {
            qfDiscl = ticket?.race_desc;
        }else if("2" == ticketData?.ticket_type) {
            qfDiscl = getLabel("printer.plain_ticket.header.system_bets");
        }
    }else if(isTotPsrType) {
        let infoCompetition = ticket?.concorso? 'Conc. '+ ticket.concorso + ' - ':''
        topPsrDiscl = infoCompetition + ticket?.riunione +' ' + ticket?.ora_corsa +' corsa ' + ticket?.corsa;
    }

    // this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = idString === '' ? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}

    
    const clearBoth = {clear: "both"};
	
	function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}

   
    return (
        <>
        {frontendType === 'SELF-CASHIER' && window.NUM_CASSA && window.NUM_CASSA != 0 && (
			<div>
				<div style={{marginLeft : "30%", fontSize:"15px"}}>{getLabel('retail.cashier_number')}  {window.NUM_CASSA} </div>
			</div>
		)
	    }
        
        <div id="header-logos">
            <div id="customer-logo">
            {
                props.customerLogo != null && props.customerLogo.length > 0 && (
                        <img src={props.customerLogo} />
                )
                
            }
            </div>
            {
                props.aamsLogo != null &&(
                        <div id="aams-logo">
                            <img src={props.aamsLogo} />
                        </div>
                )
            }
            <div style={clearBoth}></div>
        
        </div>


        <div id="first-table" style={{fontSize : "10px"}}>
	
            <div>
                <div className="td-100 left"> {getLabel('printer.plain_ticket.header.nc')} : {ticket?.shop_desc} </div>
                <div style={clearBoth}></div>
            </div>
            <div>
                <div className="td-25 left">{'FC'} : {ticket?.fc} </div>
                <div className="td-25 left">{getLabel('printer.plain_ticket.header.cc')} : {ticket?.conc} </div>	
                <div className="td-35 left"> {getLabel('printer.plain_ticket.header.pv')} : {ticket?.shop} </div>
                <div className="td-15 left textright"> {getLabel('printer.plain_ticket.header.tm')}: {ticket?.tag}</div>
                <div style={clearBoth}></div>
            </div>

            <div>
                <div className="td-20 left"> {'AG'}: {ticketData.ag}</div> 
                <div className="td-30 left">{getLabel('printer.plain_ticket.header.ge')} : {ticket?.de}</div>
                <div className="td-25 left">{getLabel('printer.plain_ticket.header.oe')} : {ticket?.te}</div>
                <div className="td-25 left">{getLabel('printer.plain_ticket.header.tg')}-{typeGame}</div>
                <div style={clearBoth}></div>
            </div>
            

            <div>
                <div className="td-40 left">{getLabel('printer.plain_ticket.header.id') + charPAR}: {ticket?.id_ticket}</div>
                <div className="td-40 left" >{palDesc}</div>
                <div style={clearBoth}></div>
            </div>
        </div>

        {
            isFixedOddType && 
            <div className="textcenter td-100 palDisclam uppercase">{qfDiscl+' '+getLabel("printer.plain_ticket.header.fixed_odds")?.toUpperCase()}</div>
        }

        {
            isTotPsrType && 
            <div className="textcenter td-100 horseRaceNumber uppercase">{topPsrDiscl}</div>
        }

        </>
    )
}